module.exports = __webpack_public_path__ + "static/media/HiPP.2c9cd747.png";